<template>
  <div class="percent-bar-root">
    <div class="bar-container">
      <div class="bar-base"></div>
      <div class="bar-main" :style="{ width: barData.barMainWidth }">
        <div class="bar-progress" :style="{ width: `${barData.barPercent}%` }"></div>
      </div>
      <div class="bar-step-bg0"></div>
      <div class="bar-step0">
        <div class="tips-root">
          <div class="bar-tips0">
            <div v-if="barData.tips0Percent" class="tips-row tips-row-percent">
              <span>{{ barData.tips0Percent }}</span>
            </div>
            <div v-if="barData.tips0Value" class="tips-row tips-row-value">
              <img :src="getMatchImg('beans')" alt="" />
              <span>{{ barData.tips0Value }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="barData.step1Show" class="bar-step-bg1"></div>
      <div v-if="barData.step1Show" class="bar-step1">
        <div class="tips-root">
          <div class="bar-tips1">
            <div v-if="barData.tips1Percent" class="tips-row tips-row-percent">
              <span>{{ barData.tips1Percent }}</span>
            </div>
            <div v-if="barData.tips1Value" class="tips-row tips-row-value">
              <img :src="getMatchImg('beans')" alt="" />
              <span>{{ barData.tips1Value }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="barData.step2Show" class="bar-step-bg2"></div>
      <div
        v-if="barData.step2Show"
        class="bar-step2"
        :class="{ 'step-virtual': barData.step2Virtual }"
      >
        <div class="tips-root">
          <div class="bar-tips2">
            <div v-if="barData.tips2Percent" class="tips-row tips-row-percent">
              <span>{{ barData.tips2Percent }}</span>
            </div>
            <div v-if="barData.tips2Value" class="tips-row tips-row-value">
              <img :src="getMatchImg('beans')" alt="" />
              <span>{{ barData.tips2Value }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bar-step-bg3"></div>
      <div class="bar-step3">
        <div class="tips-root">
          <div class="bar-tips3">
            <div v-if="barData.tips3Percent" class="tips-row tips-row-percent">
              <span>{{ barData.tips3Percent }}</span>
            </div>
            <div v-if="barData.tips3Value" class="tips-row tips-row-value">
              <img :src="getMatchImg('beans')" alt="" />
              <span>{{ barData.tips3Value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubAgentEventPercentBar',
  props: {
    percentCount: {
      type: Number,
      default: 0,
    },
    earnTypeList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      barData: {
        barMainWidth: '0%',
        barPercent: '0%',
        step1Show: true,
        step2Show: true,
        step2Virtual: false,
        tips0Value: '',
        tips0Percent: '',
        tips1Value: '',
        tips1Percent: '',
        tips2Value: '',
        tips2Percent: '',
        tips3Value: '',
        tips3Percent: '',
      },
    }
  },
  watch: {
    earnTypeList: {
      handler: 'updateBarData',
      deep: true,
      immediate: true,
    },
    percentCount: 'updateBarData',
  },
  methods: {
    getTierPositions() {
      return { step0: 0, step1: 60, step2: 85, step3: 100 }
    },
    formatTierTips(tier) {
      if (!tier) {
        return { percent: '', value: '' }
      }
      return {
        percent: String(tier.minBeans ?? ''),
        value: this.thousandthDigit(tier.rewardBean ?? 0),
      }
    },
    findAchievedTier(tiers, currentCount) {
      let achieved = null
      tiers.forEach((tier) => {
        if ((tier.minBeans ?? 0) <= currentCount) {
          achieved = tier
        }
      })
      return achieved
    },
    findUpcomingTier(tiers, currentCount) {
      return tiers.find((tier) => (tier.minBeans ?? 0) > currentCount) ?? null
    },
    hasMiddleTiers(tiers, upcomingTier) {
      if (!upcomingTier || tiers.length <= 1) {
        return false
      }
      const upcomingIdx = tiers.findIndex((tier) => (tier.minBeans ?? 0) === (upcomingTier.minBeans ?? 0))
      return upcomingIdx >= 0 && tiers.length - 1 - upcomingIdx > 1
    },
    calcSegmentPercent(currentCount, fromCount, toCount) {
      if (toCount <= fromCount) {
        return 0
      }
      if (currentCount <= fromCount) {
        return 0
      }
      if (currentCount >= toCount) {
        return 100
      }
      let percentRes = ((currentCount - fromCount) / (toCount - fromCount)) * 100
      if (percentRes > 0 && percentRes < 10) {
        return 10
      }
      return percentRes
    },
    calcProgressPosition(currentCount, lastTier, nextTier, lastPos, nextPos) {
      if (!nextTier || nextPos <= lastPos) {
        return lastPos
      }
      const lastCount = lastTier?.minBeans ?? 0
      const nextCount = nextTier.minBeans ?? 0
      if (nextCount <= lastCount) {
        return lastPos
      }
      if (currentCount <= lastCount) {
        return lastPos
      }
      if (currentCount >= nextCount) {
        return nextPos
      }
      const ratio = (currentCount - lastCount) / (nextCount - lastCount)
      return lastPos + ratio * (nextPos - lastPos)
    },
    getEmptyBarData() {
      return {
        barMainWidth: '0%',
        barPercent: 0,
        step1Show: false,
        step2Show: false,
        step2Virtual: false,
        tips0Percent: '',
        tips0Value: '',
        tips1Percent: '',
        tips1Value: '',
        tips2Percent: '',
        tips2Value: '',
        tips3Percent: '',
        tips3Value: '',
      }
    },
    updateBarData() {
      const positions = this.getTierPositions()
      const copyArr = this.earnTypeList.slice()
      const tiers = []
      copyArr.forEach((ele) => {
        if (!tiers.some((item) => ele.minBeans === item.minBeans && ele.rewardBean === item.rewardBean)) {
          tiers.push(ele)
        }
      })
      tiers.sort((a, b) => (a.minBeans ?? 0) - (b.minBeans ?? 0))

      if (!tiers.length) {
        this.barData = this.getEmptyBarData()
        return
      }

      const currentCount = this.percentCount ?? 0
      const emptyTips = { percent: '', value: '' }
      const finalTier = tiers[tiers.length - 1]
      const achievedTier = this.findAchievedTier(tiers, currentCount)
      const upcomingTier = this.findUpcomingTier(tiers, currentCount)
      const showStep1 = !!(upcomingTier && upcomingTier !== finalTier)
      const showStep2Virtual = showStep1 && this.hasMiddleTiers(tiers, upcomingTier)

      const tips0 = achievedTier
        ? this.formatTierTips(achievedTier)
        : currentCount === 0
          ? { percent: '0', value: '' }
          : emptyTips
      const tips1 = showStep1 ? this.formatTierTips(upcomingTier) : emptyTips
      const tips3 = this.formatTierTips(finalTier)

      let barMainWidth = '100%'
      let barPercent = 0

      if (showStep1) {
        barMainWidth = `${positions.step1}%`
        const fromCount = achievedTier?.minBeans ?? 0
        barPercent = this.calcSegmentPercent(currentCount, fromCount, upcomingTier.minBeans ?? 0)
      } else if (currentCount >= (finalTier.minBeans ?? 0)) {
        barPercent = 100
      } else {
        barPercent = this.calcProgressPosition(
          currentCount,
          achievedTier || { minBeans: 0 },
          finalTier,
          positions.step0,
          positions.step3
        )
      }

      this.barData = {
        barMainWidth,
        barPercent,
        step1Show: showStep1,
        step2Show: showStep2Virtual,
        step2Virtual: showStep2Virtual,
        tips0Percent: tips0.percent,
        tips0Value: tips0.value,
        tips1Percent: tips1.percent,
        tips1Value: tips1.value,
        tips2Percent: '',
        tips2Value: '',
        tips3Percent: tips3.percent,
        tips3Value: tips3.value,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$step-size: 12px;
$step-border: 2.5px;
$step-inner: $step-size - $step-border * 2;
$step2-border: 2px;
$step2-inner: $step-size - $step2-border * 2;
$step1-position: 60%;
$step2-position: 85%;
$step-offset: 10px;

.percent-bar-root {
  width: 100%;
  min-height: 80px;
  display: flex;
  align-items: center;

  .bar-container {
    width: 100%;
    min-height: 12px;
    position: relative;
    display: flex;
    align-items: center;

    .bar-base {
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 4px;
      background: #e0caee;
      border-radius: 7px;
      transform: translateY(-50%);
      z-index: 2;
    }

    .bar-main {
      position: relative;
      width: $step1-position;
      z-index: 3;

      .bar-progress {
        height: 4px;
        background: #b94cff;
        border-radius: 7px;
        position: relative;
      }
    }

    .bar-step-bg0,
    .bar-step-bg1,
    .bar-step-bg2,
    .bar-step-bg3 {
      box-sizing: border-box;
      width: $step-size;
      height: $step-size;
      border-radius: 50%;
      background-color: #e0caee;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    .bar-step0,
    .bar-step1,
    .bar-step2,
    .bar-step3 {
      box-sizing: border-box;
      width: $step-inner;
      height: $step-inner;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 4;

      .tips-root {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: visible;
      }

      .bar-tips0,
      .bar-tips1,
      .bar-tips2,
      .bar-tips3 {
        position: absolute;
        bottom: -38px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow: visible;
        white-space: nowrap;

        .tips-row {
          display: inline-flex;
          align-items: center;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-12);
          line-height: var(--lh-label-16);
          color: #666666;
        }

        .tips-row-value {
          min-height: 14px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-10);
          line-height: var(--lh-label-14);

          img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
            flex-shrink: 0;
          }
        }
      }

      .bar-tips0 {
        left: -3px;
      }

      .bar-tips1 {
        width: 118px;
        left: 50%;
        align-items: center;
        margin-left: -59px;
      }

      .bar-tips2 {
        width: 118px;
        left: 50%;
        align-items: center;
        margin-left: -59px;
      }

      .bar-tips3 {
        right: 0;
        align-items: flex-end;
      }
    }

    .bar-step1 {
      width: $step2-inner;
      height: $step2-inner;
      background-color: #b94cff;
      left: calc(#{$step1-position} - #{$step-offset} + #{$step2-border});
    }

    .bar-step-bg0 {
      left: -$step-border;
    }

    .bar-step0 {
      background-color: #b94cff;
      left: 0;
    }

    .bar-step-bg1 {
      left: calc(#{$step1-position} - #{$step-offset});
    }

    .bar-step-bg2 {
      left: calc(#{$step2-position} - #{$step-offset});
    }

    .bar-step2 {
      background-color: #b94cff;
      left: calc(#{$step2-position} - #{$step-offset} + #{$step2-border});

      &.step-virtual {
        width: $step-inner;
        height: $step-inner;
        background-color: #baa7c4;
        left: calc(#{$step2-position} - #{$step-offset} + #{$step-border});
      }
    }

    .bar-step-bg3 {
      left: calc(100% - #{$step-offset});
    }

    .bar-step3 {
      background-color: #b94cff;
      left: calc(100% - #{$step-offset} + #{$step-border});
    }
  }
}
</style>

<style lang="scss">
$step1-position: 60%;
$step2-position: 85%;
$step-offset: 10px;
$step-border: 2.5px;
$step2-border: 2px;

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .percent-bar-root {
    .bar-container {
      overflow: visible;

      .bar-main {
        overflow: visible;
      }

      .bar-step-bg0,
      .bar-step-bg1,
      .bar-step-bg2,
      .bar-step-bg3,
      .bar-step0,
      .bar-step1,
      .bar-step2,
      .bar-step3 {
        .bar-tips0,
        .bar-tips1,
        .bar-tips2,
        .bar-tips3 {
          .tips-row-value img {
            margin-right: 0;
            margin-left: 4px;
          }
        }

        .bar-tips0 {
          right: -3px;
          left: auto;
        }

        .bar-tips1 {
          right: 50%;
          left: auto;
          margin-right: -59px;
          margin-left: auto;
        }

        .bar-tips2 {
          right: 50%;
          left: auto;
          margin-right: -59px;
          margin-left: auto;
        }

        .bar-tips3 {
          right: auto;
          left: 0;
        }
      }

      .bar-step-bg0,
      .bar-step0 {
        right: 0;
        left: auto;
      }

      .bar-step0 {
        right: $step-border;
      }

      .bar-step-bg1,
      .bar-step1 {
        right: calc(#{$step1-position} - #{$step-offset});
        left: auto;
      }

      .bar-step1 {
        right: calc(#{$step1-position} - #{$step-offset} + #{$step2-border});
      }

      .bar-step-bg2,
      .bar-step2 {
        right: calc(#{$step2-position} - #{$step-offset});
        left: auto;
      }

      .bar-step2 {
        right: calc(#{$step2-position} - #{$step-offset} + #{$step2-border});

        &.step-virtual {
          right: calc(#{$step2-position} - #{$step-offset} + #{$step-border});
        }
      }

      .bar-step-bg3,
      .bar-step3 {
        right: calc(100% - #{$step-offset});
        left: auto;
      }

      .bar-step3 {
        right: calc(100% - #{$step-offset} + #{$step-border});
      }
    }
  }
}
</style>
